import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../buttons';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, SimpleShowLayout } from '../../controllers';
import { EnumField, LinkField, NumberField, TextField } from '../../fields';
import { BooleanInput, EnumInput, NumberInput, TextInput } from '../../inputs';
import guide_rank_learning_path_levels from './guide_rank_learning_path_levels';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="name"
        />
        <EnumInput
          source="difficulty_level"
          required
        />
        <NumberInput
          source="minutes"
          required
        />
        <NumberInput
          source="position"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        {...props}
      >
        <TextInput
          source="name"
        />
        <EnumInput
          source="difficulty_level"
          required
        />
        <NumberInput
          source="minutes"
          required
        />
        <NumberInput
          source="position"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <NumberField
          source="minutes"
        />
        <EnumField
          source="difficulty_level"
        />
        <NumberField
          source="position"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="name"
        />
        <NumberField
          source="minutes"
        />
        <EnumField
          source="difficulty_level"
        />
        <NumberField
          source="position"
        />

        <NestedResourceList
          reference="guide_rank_learning_path_levels"
        >
          <LinkField
            source="learning_path_level_id"
          />
        </NestedResourceList>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >

        <NestedResourceList
          reference="guide_rank_learning_path_levels"
        >
          <LinkField
            source="learning_path_level_id"
          />
        </NestedResourceList>

      </SimpleShowLayout>
    ),
  },
  resources: {
    guide_rank_learning_path_levels
  },
};
